<template>
    <textarea class="form-control inputElement" rows="10" :id="'value-'+id" autocomplete="off">{{value}}</textarea>
    
</template>

<script>
export default {
  name: "TextInput",
  data() {
    return {
      output: {}
    };
  },
  props: ["value", "id"]
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/input/BigTextInput.vue